type NullOrUndefined = null | undefined;

export const isNil = (
    value: unknown
): value is NullOrUndefined => (
    value === null ||
    value === undefined
);
